/**
 * @desc 进销存导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportCustomsSale.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportCustomsSale`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
